import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export default normalize(function (options) {
  ks.pageScrollTo(options);
}, CONTAINER_NAME.KWAI);